import type { Options } from "@anthropic-ai/claude-agent-sdk";

// Derived from the SDK's own `query()` options rather than redeclared, so if
// the SDK ever tightens `model`/`effort` beyond a bare `string`/`EffortLevel`,
// mismatches here surface as type errors instead of silent drift. The SDK
// does not export a literal-type union for valid model ids (unlike effort),
// so this can't catch a wrong model id at compile time — only a type-shape
// mismatch.
export type ModelId = NonNullable<Options["model"]>;
export type EffortLevelValue = NonNullable<Options["effort"]>;

export type ModelOpt = {
  readonly hint: string;
  readonly value: ModelId;
};

export type EffortOpt = {
  readonly hint: string;
  readonly value: EffortLevelValue;
};

// Capability-descending, each tier's current model above the older ones kept
// for tasks and settings already pinned to them.
export const MODEL_OPTS: readonly ModelOpt[] = [
  { hint: "most capable · priciest", value: "claude-fable-5-1" },
  { hint: "previous-generation Fable", value: "claude-fable-5" },
  { hint: "long-horizon coding · slower", value: "claude-opus-5-5" },
  { hint: "previous-generation Opus", value: "claude-opus-5" },
  { hint: "older Opus", value: "claude-opus-4-8" },
  { hint: "balanced · recommended", value: "claude-sonnet-5" },
  { hint: "fastest · cheapest", value: "claude-haiku-4-5" },
];

export const EFFORT_OPTS: readonly EffortOpt[] = [
  { hint: "fastest · least reasoning", value: "low" },
  { hint: "balanced", value: "medium" },
  { hint: "deep reasoning · recommended", value: "high" },
  { hint: "deeper reasoning · slower", value: "xhigh" },
  { hint: "maximum reasoning · slowest", value: "max" },
];

export const DEFAULT_MODEL: ModelId = "claude-sonnet-5";
export const DEFAULT_EFFORT: EffortLevelValue = "high";
